import { IColumn } from '@/components/message-center/GridColumns';

export const historyGridColumns: IColumn[] = [
  {
    field: 'userId',
    title: 'User',
    show: true,
    width: '125px',
    alwaysVisible: true,
  },
  {
    field: 'action',
    title: 'Action',
    show: true,
    width: '140px',
    alwaysVisible: true,
  },
  {
    field: 'fieldName',
    title: 'Field Name',
    show: true,
    width: '170px',
    alwaysVisible: true,
  },
  {
    field: 'previousValue',
    title: 'Previous Value',
    show: true,
    alwaysVisible: true,
  },
  {
    field: 'newValue',
    title: 'New Value',
    show: true,
    alwaysVisible: true,
  },
  {
    field: 'updated',
    title: 'Timestamp',
    filter: 'date',
    show: true,
    alwaysVisible: true,
  },
];
